import { render, staticRenderFns } from "./myCreate.vue?vue&type=template&id=21815adc&scoped=true&lang=pug"
import script from "./myCreate.vue?vue&type=script&lang=js"
export * from "./myCreate.vue?vue&type=script&lang=js"
import style0 from "./myCreate.vue?vue&type=style&index=0&id=21815adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21815adc",
  null
  
)

export default component.exports